import { AiPromptsSettings } from './AiPromptsSettings.main';

export { AiPromptsSettings };
